import { Injectable } from '@angular/core';
import { FirebaseApp } from '@angular/fire';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { ToastController } from '@ionic/angular';
import { TimelineService } from './timeline.service';
import { XprlService } from './xprl.service';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public static MY_ACCOUNT_ID = '';

  currentRewardID:number;
  allClaimsToCheck;
  rewards = [];
  account;
  myId;
  isLoggedIn = false;
  myImageAvatar;
  peekingProfile;
  kompasSkonczony = false;
  savedKey;
  currentClaimID:string;
  shouldGetManual = false;
  currentClaim:any = {
    claimedStatus : 'INIT'
  };

  exceptionSent = false;
  allExceptions;

  requestCoolDown = false;

  constructor(private toastController: ToastController,
              public afa: AngularFireAuth, 
              private afs: AngularFirestore, private timelineService: TimelineService)
  {
    this.afa.authState.subscribe(user => {

        if (user)
        {

          const { uid, email } = user;

          this.account = user;
          // console.log('JEST KOLO', user.uid);

          this.isLoggedIn = true;

          this.myId = user.uid;

          this.timelineService.appPages[1].url = '/profile/' + this.myId;

          // this.app.refresh(user.uid);

          if (!user.email)
          {
            // console.log('BRAK @ maila');
            //  this.account
          }

          if (user.isAnonymous === true)
          {
            console.log('ANON MODE - ON!!!');

          }
        }
        else
        {
          // console.log('BRAK KOLO');
        }

    });
  }

  async saveMyImage(userId, avatarNew) {
    this.afs.doc('accounts/' + userId).update({ avatar: avatarNew });
  }

  async saveMyPubKey(userId, pubkeyNew) {
    this.afs.doc('accounts/' + userId).update({ pubKey: pubkeyNew });
  }

  async sendException(exception) {
    this.afs.collection('exceptions').add(
      { 
        exception: exception,
        currStatus: 'PENDING'
      }
    ).then(excSaved=>{
      console.log('excSaved', excSaved.id);
      this.exceptionSent = true;
      this.presentClaimExceptionSaved(excSaved.id);
      localStorage.setItem("exceptionSentForClaim_"+exception.currentReward, excSaved.id);
    })
  }

  async sendClaim(userId, pubkey, currentReward) {

    console.log("CLAIM req", userId, pubkey, currentReward);

    this.afs.collection("claims").add({
      claimer: userId,
      pubKey: pubkey,
      currentReward: currentReward
    })
    .then((docRef) => {
        console.log("CLAIM written with ID: ", docRef.id);
        this.presentClaimSaved(docRef.id);
        this.currentClaimID = docRef.id;

        this.getCurrentClaimData(docRef.id).subscribe((currClaim: any) => {
          console.log('currClaim sub', currClaim);
          this.currentClaim = currClaim;
          
        });
    })
    .catch((error) => {
        console.error("Error adding document: ", error);
    });
  }


  async getAccount(userId = null) {
    
      // console.log('TAKE userId', userId);

      const currentUser = userId ? userId : AuthService.MY_ACCOUNT_ID;
 
      if (!currentUser || currentUser === 'undefined' || currentUser === '')
      {
        console.log('NO currentUser');
        return null;
      }

      const doc: any = this.afs.doc('accounts/' + currentUser);
      // console.log('kogo doc', userId, currentUser, doc);

      if (!doc)
      {
        return { null: true };
      }

      return this.account = doc.valueChanges();
    
  }

  async presentRenderWarningOptions() {

    const rnd = Math.random();
    if (rnd > 0.4) { return; }


    const toast = await this.toastController.create({
      header: '[WARNING] - Alpha v0.5.1',
      message: "Refresh your browser if you don't see FCX Compass",
      position: 'top',
      duration: 10000,
      buttons: [
        {
          text: 'Ok',
          role: 'cancel',
          handler: () => {
            console.log('ok clicked');
            // this.router.navigate(['/kompas']);
          }
        }
      ]
    });
    toast.present();
  }

  async presentClaimExceptionSaved(exceptionID) {
    
    const toast = await this.toastController.create({
      header: '[EXCEPTION REPORTED] - ID:'+ exceptionID,
      message: "Your reward exception has been sent. FCX team will take care of that as soon as possible." ,
      position: 'top',
      buttons: [
        {
          text: 'Ok',
          role: 'cancel',
          handler: () => {
            console.log('ok clicked');
            // this.router.navigate(['/kompas']);
          }
        }
      ]
    });
    toast.present();
  }


  async presentClaimSaved(claimID) {
    
    const toast = await this.toastController.create({
      header: '[CLAIM ID] - '+ claimID,
      message: "If all is legit, you should receive your reward very soon." ,
      position: 'top',
      buttons: [
        {
          text: 'Ok',
          role: 'cancel',
          handler: () => {
            console.log('ok clicked');
            // this.router.navigate(['/kompas']);
          }
        }
      ]
    });
    toast.present();
  }


  getCurrentClaimData(uid)
  {
    return this.afs.collection('claims').doc(uid).valueChanges();
  }

  getAllExceptionsForWallet(pubKey)
  {  
    return this.afs.collection('exceptions', ref => ref.where('exception.pubKey', '==', pubKey)).valueChanges();  
  }

  

  getAllClaimsForWallet(pubKey)
  {
    //return this.afs.collection('claims').doc(uid).valueChanges();
  
    return this.afs.collection('claims', ref => ref.where('pubKey', '==', pubKey).orderBy('currentReward', 'desc')).valueChanges();  
  }

  getCurrentClaimDataByCurrentNUM(currentRewardNUM)
  {
    //return this.afs.collection('claims').doc(uid).valueChanges();
  
    return this.afs.collection('claims', ref => ref.where('pubKey', '==', XprlService.MY_PUBLIC).where('currentReward', '==', currentRewardNUM)).valueChanges();
                // this.afs.doc(documentSnapshot.ref).valueChanges().subscribe(console.log);
  
  }


  getKompasData(uid)
  {
    return this.afs.collection('accounts').doc(uid).valueChanges();
  }

  getCurrentRewardData()
  {
    return this.afs.collection('rewards').doc('currentReward').valueChanges();
  }

  getAllExceptions()
  {
    //return this.afs.collection('claims').doc(uid).valueChanges();
  
    return this.afs.collection('exceptions', ref => ref.where('currStatus', '==', 'PENDING')).valueChanges({ idField: 'id' });  
  }


  getRewardsData()
  {
    return this.afs.collection('rewards', ref => ref.orderBy('inLedger', 'desc').limit(10)).snapshotChanges();
  }

  getRecentKompasData()
  {
    return this.afs.collection('accounts', ref => ref.orderBy('createdAt', 'desc')).snapshotChanges();
  }

  deleteKompasData(uid)
  {
    return this.afs.collection('accounts').doc(uid).valueChanges();
  }
  
  public czekAccount()
  {
    console.log('czekAccount', this.account);
  }

}
